module.exports = __webpack_public_path__ + "media/images/xc_4-52a357b1409c45940f4bf4636a02e6cb.png";